import { useAppActions } from 'reducers/slices/statesSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { loadStates } = useAppActions();
  const { loading, states } = useSelector(state => state.statesSlice);

  return {
    loadStates,
    loading,
    states,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useStates.js